import styled from 'styled-components';
import { ThemeMode } from '../../../../../global-state/themeContext';
import { Typography } from '../../../../../stories/atoms';
import { Color } from '../../../../../theme';
import { AccuracyValueEnum } from './stockAccuracyCard/StockAccuracyCard';

export const FlexRow = styled.div`
  display: flex;
`;

export const FlexColumn = styled(FlexRow)`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled(FlexColumn)<{ isMobile: boolean }>`
  padding: ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme, isMobile }) => (isMobile ? theme.spacing(3) : theme.spacing(4))};
  flex: 1;
`;

export const Section = styled(FlexRow)<{ isMobile: boolean }>`
  gap: ${({ theme, isMobile }) => (isMobile ? theme.spacing(3) : theme.spacing(4))};
  flex: 1;
`;

export const AccuracyContainer = styled(FlexColumn)<{ isMobile: boolean }>`
  width: 100%;
  justify-content: space-between;
  padding: ${({ theme, isMobile }) => (isMobile ? theme.spacing(2) : theme.spacing(3))};
  border-radius: ${({ theme }) => theme.spacing(4)};
  border: 1px solid
    ${({ theme: { color, palette } }) => (palette.mode === 'dark' ? color.borderGrayDark : color.borderGray)};
`;

const getValueColor = (accuracy: AccuracyValueEnum, mode: ThemeMode, color: Color): string | undefined => {
  const colorMapping = {
    [AccuracyValueEnum.SUCCESS]: mode === 'dark' ? color.success : color.validationGreen,
    [AccuracyValueEnum.WARNING]: mode === 'dark' ? color.warningLight : color.warningDark,
    [AccuracyValueEnum.ERROR]: mode === 'dark' ? color.error : color.red,
  };

  return colorMapping[accuracy];
};

export const StyledValueTypography = styled(Typography)<{ accuracy: AccuracyValueEnum; showColor: boolean }>`
  color: ${({ theme: { palette, color }, accuracy, showColor }) =>
    showColor && getValueColor(accuracy, palette.mode, color)};
`;

export const HeaderContainer = styled(FlexRow)`
  align-items: center;
`;
